// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"246":"cea8006d","453":"39243f2b","563":"db00139e"}[chunkId] + ".chunk.js";
};